export default function ExitIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M9.5 6.75L7.25 9M7.25 9L9.5 11.25M7.25 9H16.25"
        stroke="#FF3838"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 5.625V5.625C11.75 3.76104 10.239 2.25 8.375 2.25H6.75C4.54086 2.25 2.75 4.04086 2.75 6.25V11.75C2.75 13.9591 4.54086 15.75 6.75 15.75H8.375C10.239 15.75 11.75 14.239 11.75 12.375V12.375"
        stroke="#FF3838"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
